import { message as Message } from "ant-design-vue"
import {
    MessageOptions,
    ConfigDuration,
    ConfigOnClose,
    MessageConfigOptions
} from "ant-design-vue/types/message"
import { VNode } from "vue"
import shared from "@/config/shared"
let msgQueue: (string | VNode)[] = []

function isPrimitiveError(message: string): boolean {
    return [
        "ReferenceError",
        "TypeError",
        "SyntaxError",
        "RangeError",
        "EvalError",
        "URIError"
    ].some(type => message.includes(type))
}

function isUndefinedError(message: string) {
    return message.includes("undefined")
}

function isHttpError(message: string) {
    return message.includes("Request failed with status code")
}
function isTimeoutError(message: string) {
    return message.includes("timeout")
}
function isNetworkError(message: string) {
    return message.includes("Network Error")
}

const { errorNotice } = shared

// TODO 处理vnode和((h: CreateElement) => VNode)的情况
function commonMessage(
    type: string,
    content: any,
    duration?: ConfigDuration,
    onClose?: ConfigOnClose
) {
    let message = ""
    const c_type = Object.prototype.toString.call(content)
    if (c_type === "[object String]") {
        // 传入的纯字符串
        message = content
    } else if (c_type === "[object Error]") {
        // 代码错误传入的Error
        message = content.toString()
    } else if (
        c_type === "[object Object]" &&
        Object.prototype.toString.call(content.content) === "[object Error]"
    ) {
        // Object中传入的代码错误Error
        message = content.content.toString()
    } else {
        // 传入的Object
        message = content.content
    }

    let newMessage = message
    duration = type !== "[object Object]" ? duration : content.duration
    onClose = type !== "[object Object]" ? onClose : content.onClose
    if (typeof message === "string") {
        if (isPrimitiveError(message) || isUndefinedError(message)) {
            // 前端语法错误
            newMessage = `系统错误，如需帮助请联系：${errorNotice.front}`
            window.fLog.errorCallback(new Error(message))
        } else if (isNetworkError(message)) {
            newMessage = `网络错误，请检查网络是否连接正常，如需帮助请：${errorNotice.it}`
        } else if (isTimeoutError(message)) {
            newMessage = `系统超时，请重新操作或联系：${errorNotice.backend}`
        } else if (isHttpError(message)) {
            // 后端接口错误
            newMessage = `系统错误，如需帮助请联系：${errorNotice.backend}`
        } else if (message.length > 100) {
            // 后端一大长串错误兜底
            newMessage = `系统错误，如需帮助请联系：${errorNotice.backend}`
        }
        console.error(message)
        // 业务码错误暂时不作处理
    }

    if (!msgQueue.includes(newMessage)) {
        msgQueue.push(newMessage)
        if (type !== "[object Object]") {
            ;(Message as any)[type]({
                content: newMessage,
                duration,
                onClose: () => {
                    msgQueue = msgQueue.filter(msg => newMessage !== msg)
                    onClose && onClose()
                }
            })
        } else {
            ;(Message as any)[type]({
                ...content,
                content: newMessage,
                onClose: () => {
                    msgQueue = msgQueue.filter(msg => newMessage !== msg)
                    onClose && onClose()
                }
            })
        }
    }
}

const showMessage: any = {
    open: (config: MessageOptions) => {
        Message.success(config)
    },
    config: (options: MessageConfigOptions) => {
        Message.config(options)
    },
    destroy: () => {
        Message.destroy()
    }
}
;["success", "info", "warn", "warning", "error", "loading", "open", "config", "destroy"].map(
    type => {
        showMessage[type] = (content: any, duration?: ConfigDuration, onClose?: ConfigOnClose) => {
            commonMessage(type, content, duration, onClose)
        }
    }
)

export default showMessage as any
